import { TIPO_FONE } from "@repo/core/services/entities/Proposals";

export function normalizeResidentialPhone2TipoToFormValue(
  value?: string | null
): string {
  if (value === undefined || value === null) {
    return "";
  }
  const trimmed = String(value).trim();
  if (trimmed === "") {
    return "";
  }
  if (trimmed === "1" || trimmed === "2") {
    return trimmed;
  }
  const upper = trimmed.toUpperCase();
  switch (upper) {
    case TIPO_FONE.CONVENCIONAL:
    case "CONVENCIONAL":
      return "1";
    case TIPO_FONE.CELULAR:
    case "CELULAR":
      return "2";
    case TIPO_FONE.EMPRESA:
    case "EMPRESA":
      return "EMPRESA";
    case TIPO_FONE.RECADOS:
    case "RECADOS":
    case "4":
      return "RECADOS";
    default:
      return "";
  }
}

/**
 * Maps RESTIPOFONE2 UI values / legacy descriptive strings to API codes "1", "2", "4".
 */
export function normalizeResidentialPhone2TipoToApiCode(
  value?: string | null
): string {
  if (value === undefined || value === null) {
    return "";
  }
  const trimmed = String(value).trim();
  if (trimmed === "") {
    return "";
  }
  if (trimmed === "1" || trimmed === "2" || trimmed === "4") {
    return trimmed;
  }
  const upper = trimmed.toUpperCase();
  switch (upper) {
    case TIPO_FONE.CONVENCIONAL:
    case "CONVENCIONAL":
      return "1";
    case TIPO_FONE.CELULAR:
    case "CELULAR":
      return "2";
    case TIPO_FONE.RECADOS:
    case "RECADOS":
    case TIPO_FONE.EMPRESA:
    case "EMPRESA":
      return "4";
    default:
      return "";
  }
}
